import routesPath from '@/shared/constants/routesPath';

import Home from '@/pages/home';
import LiveScoring from '@/pages/livescoring';
import Terms from '@/pages/terms';

const Routes = {
  HOME: {
    index: true,
    path: routesPath.HOME,
    view: Home,
    mainLayout: true,
    permissions: [], // empty array means no permissions required, so its public
    roles: [], // empty array means no roles required, so its public
  },
  LIVESCORING: {
    path: routesPath.LIVESCORING,
    view: LiveScoring,
    mainLayout: true,
    permissions: [], // allowed [[perm1], [perm2, perm3]] means perm1 OR (perm2 and perm3)
    roles: [],
    absoluteCheck: false, // true means both permissions AND roles are required
  },
  TERMS: {
    path: routesPath.TERMS,
    view: Terms,
    mainLayout: true,
    permissions: [],
    roles: [],
  },
};

const buildRoutes = () => {
  const protectedRoutes = [];
  const publicRoutes = [];

  Object.keys(Routes).forEach((routeName) => {
    const route = Routes[routeName];
    route.path = import.meta.env.BASE_URL + route.path;

    const isProtected =
      (route.roles && route.roles.length > 0) ||
      (route.permissions && route.permissions.length > 0);

    if (isProtected) {
      protectedRoutes.push(route);
    } else {
      publicRoutes.push(route);
    }
  });

  return {
    protectedRoutes,
    publicRoutes,
  };
};
const finalRoutes = buildRoutes();

export default finalRoutes;
